import { ExpOrgActionTypes, ExpOrgActions } from './exp-org.actions';
import { IExpOrg } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IExpOrg | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: ExpOrgActions): State {
    switch (action.type) {

        case ExpOrgActionTypes.LoadExpOrgState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case ExpOrgActionTypes.LoadExpOrgStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case ExpOrgActionTypes.LoadExpOrgStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case ExpOrgActionTypes.ExpOrgScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;